import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

const useIsMobile = (breakpoint = 1050) => {
  const [isMobile, setIsMobile] = useState(false);

  const resizeCallback = debounce(() => {
    setIsMobile(window.innerWidth <= breakpoint);
  }, 200);

  useEffect(() => {
    window.addEventListener('resize', resizeCallback);
    resizeCallback();

    return () => {
      window.removeEventListener('resize', resizeCallback);
    };
  });

  return isMobile;
};

export default useIsMobile;
